module.exports = __webpack_public_path__ + "media/images/icons/twotone/exclamation-circle-f6ebbab07a64cd979aa9faefd84c4f87.svg";